import KilliamLogo from '../assets/images/logo-killiam.png';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__copyright">
                &copy; 2021 Killam Apartment REIT. All rights reserved.
                <a href="https://killamreit.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
            </div>

            <div className="footer__killiam">
                <p>Proudly developed by</p>
                <img src={KilliamLogo} alt="Killiam" />
            </div>
        </footer>
    )
}

export default Footer;